<template>
  <v-app>
    <to-old-alert></to-old-alert>

    <component :is="layout">
      <router-view></router-view>
    </component>
  </v-app>
</template>

<script>
import toOldAlert from '@/components/to-old-alert'
export default {
  name: 'App',
  components: {
    toOldAlert
  },
  data: () => ({
    //
  }),
  computed: {
    layout () {
      if (!this.$route.name) return null
      if (!this.$route.meta.layout) return 'default-layout'
      else return this.$route.meta.layout + '-layout'
    }
  }
}
</script>
